import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpLoadingProps, TitleAndDesc } from '../common';

const LogosWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cp-spacing-05);
  margin-top: var(--cp-spacing-06);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-04);
    margin-top: var(--cp-spacing-04);
  }
`;

const AvatarSkeleton = styled(Skeleton.Button)`
  &.ant-skeleton,
  .ant-skeleton {
    width: 100px !important;
    height: 100px !important;
  }

  .ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
`;

const IconSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    width: 66px !important;
    height: 66px !important;
  }

  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
`;

const Content: React.FC = () => {
  return (
    <LogosWrapper>
      <AvatarSkeleton active shape="square" />
      <IconSkeleton active shape="circle" />
      <AvatarSkeleton active shape="square" />
    </LogosWrapper>
  );
};

export const CpLogoSkeleton: React.FC<CpLoadingProps> = ({
  input,
  styles,
  variantType,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      {variantType === CpWidgetVariantType.LogoWithHeader ? (
        <TitleAndDesc
          title={input?.title as string}
          desc={input?.description as string}
        />
      ) : null}
      <Content />
    </CpSectionWrapper>
  );
};
